<template>
  <!-- <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>服务管理</el-breadcrumb-item>
      <el-breadcrumb-item>请求详情</el-breadcrumb-item>
    </el-breadcrumb>
  </div> -->

  <div>
    <DetailV1 v-if="version == 1"></DetailV1>
    <DetailV2 v-if="version == 2"></DetailV2>
  </div>
</template>

<script>
import { serviceQuestDetail } from '@/service/getData'
import DetailV1 from './detail.vue'
import DetailV2 from './detail_v2.vue'
export default {
  components: {
    DetailV1,
    DetailV2,
  },
  data() {
    return {
      version: 0,
      id: this.$route.params.id,
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await serviceQuestDetail(this.id)
      if (res.code == 0) {
        this.version = res.data.is_new_flow ? 2 : 1
      }
    },
  },
}
</script>


